import * as React from "react";
import { forwardRef } from "react";
const SvgTwoSidedArrow = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 5 12" ref={ref} {...props}><path fill="#4F4F4F" d="M2.5 0 0 4h5L2.5 0ZM2.5 12 5 8H0l2.5 4Z" /></svg>;
const ForwardRef = forwardRef(SvgTwoSidedArrow);
export default ForwardRef;